
import { defineComponent, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'AudioBtn',
  props: ['actived'],
  setup() {
    const active = ref(false)
    const audio1 = ref<HTMLAudioElement | null>(null)
    const audio2 = ref<HTMLAudioElement | null>(null)
    const audio3 = ref<HTMLAudioElement | null>(null)
    const audio4 = ref<HTMLAudioElement | null>(null)
    const audio5 = ref<HTMLAudioElement | null>(null)
    const audio6 = ref<HTMLAudioElement | null>(null)

    const play = () => {
      active.value = true

      if (audio1.value) {
        audio1.value.play()
      }
      if (audio2.value) {
        audio2.value.play()
      }
      if (audio3.value) {
        audio3.value.play()
      }
      if (audio4.value) {
        audio4.value.play()
      }
      if (audio5.value) {
        audio5.value.play()
      }
      if (audio6.value) {
        audio6.value.play()
      }
    }

    const pause = () => {
      active.value = false

      if (audio1.value) {
        audio1.value.pause()
      }
      if (audio2.value) {
        audio2.value.pause()
      }
      if (audio3.value) {
        audio3.value.pause()
      }
      if (audio4.value) {
        audio4.value.pause()
      }
      if (audio5.value) {
        audio5.value.pause()
      }
      if (audio6.value) {
        audio6.value.pause()
      }
    }

    const toggleAudio = () => {
      if (active.value) {
        pause()
      } else {
        play()
      }
    }

    onMounted(() => {
      audio1.value = document.getElementById('pow1') as HTMLAudioElement
      audio2.value = document.getElementById('pow2') as HTMLAudioElement
      audio3.value = document.getElementById('pow3') as HTMLAudioElement
      audio4.value = document.getElementById('pow4') as HTMLAudioElement
      audio5.value = document.getElementById('pow5') as HTMLAudioElement
      audio6.value = document.getElementById('pow6') as HTMLAudioElement
      window.addEventListener('visibilitychange', () => {
        if (document.visibilityState !== 'visible') {
          pause()
        }
      })
    })

    return {
      active,
      toggleAudio
    }
  }
})
